const resumeData = {
  imagebaseurl: "images/profile.jpg",
  name: "Aditya Tekur",
  role: "Software Developer, Student and a Gooner all rolled in one",
  linkedinId: "https://www.linkedin.com/in/aditya-tekur-b556b2129/",
  roleDescription:
    " I like to learn and create applications in various parts of software development. I frequently read up on tech articles or simply watch historical documentaries and soccer in my free time.",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/aditya-tekur-b556b2129/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/aditek1105",
      className: "fa fa-github",
    },
    {
      name: "twitter",
      url: "https://twitter.com/im_tekur",
      className: "fa fa-twitter",
    },
  ],
  aboutme:
    "I am currently a Masters student at Northeastern University pursuing Computer Science. I'm currently diving deeper into the world of Software Development with a keen interest in Cloud Computing.",
  address: "United States",
  website: "aditek1105@gmail.com",
  education: [
    {
      UniversityName: "Northeastern University, Boston",
      specialization: "Master of Science in Computer Science",
      MonthOfPassing: "September",
      YearOfPassing: "2019 - Current ",
      Achievements:
        "Foundations of Software Engineering | Database Management Systems | Program Design Paradigm | Data Mining Techniques | Algorithms ",
    },
    {
      UniversityName:
        "SRM Institute of Science of and Technology, Kattankulathur",
      specialization: "Bachelor of Technology in Information Technology",
      MonthOfPassing: "July",
      YearOfPassing: "2015 - May 2019",
      Achievements:
        "Operating Systems | Computer Networks | Fundamentals of Cloud Computing | Internet of Things | Data Structures and Alogrithms and more...",
    },
  ],
  work: [
    {
      CompanyName: "Wasabi Technologies, Boston",
      specialization: "Software Engineer Co-op",
      MonthOfLeaving: "Jan",
      YearOfLeaving: "2021 - Current",
      Achievements: "To be updated.. ",
    },
    {
      CompanyName:
        "Graduate Teaching Assitant, Northeastern University, Boston",
      specialization: "CS3200 Database Design",
      MonthOfLeaving: "September",
      YearOfLeaving: "2020 - December 2020",
      Achievements:
        " Assisting and mentoring students in groups during office hours and on an individual basis to improve their understanding about concepts of the subject also graded assignments and examinations as assigned by the professor and setting Question Papers and conducting Quizzes for students as per the requirements of the subject.",
    },
    {
      CompanyName: "Xebia, Gurugram",
      specialization: "Web Development Engineer Intern",
      MonthOfLeaving: "May",
      YearOfLeaving: "2018 - June 2018",
      Achievements:
        " Created database using SQLite and fixed live bugs in the mobile applications for clients. Designed the User Interface using Java, XML which helped transfer the Company’s applications from the Traditional Mobile Storage to the Firebase setup of Android.",
    },
    {
      CompanyName: "Mindrops Solutions, New Delhi",
      specialization: "Android Developer Intern",
      MonthOfLeaving: "June",
      YearOfLeaving: "2017 - July 2017",
      Achievements:
        " Designed a page of recognition for the company using ReactJs. Implemented Pagination and Keyword Extraction Feature. Created a Search Bar to filter out employees. Extracted information of the employees through JSON that reduced the need for storage on the server.",
    },
  ],
  skillsDescription:
    "Java, C, C++, Python, Golang , MySQL, MongoDB, HTML, TypeScript, CSS, ReactJS, JavaScript",
  portfolio: [
    {
      name: "Content Based Recommender System",
      description: "Recommender System",
      imgurl: "images/content-based.png",
      giturl: "https://github.com/aditek1105/Content-Based-Recommender-System",
    },
    {
      name: "Collaborative Based Recommender System",
      description: "Recommender System",
      imgurl: "images/collaborative-filtering.png",
      giturl:
        "https://github.com/aditek1105/Collaborative-Based-Recommender-System",
    },
    {
      name: "Web Crawler",
      description: "Crawler written in Python",
      imgurl: "images/web-crawler.jpeg",
      giturl: "https://github.com/aditek1105/Web-Crawler",
    },
    {
      name: "Unusual Characteristics of an animal in a herd",
      description: "Deep Learning",
      imgurl: "images/dl.jpeg",
      giturl: "https://github.com/aditek1105/Btech-Major-Project",
    },
  ],
};
export default resumeData;
